import type { PTZ } from '@studio/models/ptz';
import type { Transform } from './types.js';

/** Transformation pipeline. */
export class Pipeline {
  #transforms: Transform[];

  /**
   * Constructs a transformation pipeline.
   *
   * @param transforms - Transforms.
   */
  public constructor(...transforms: Transform[]) {
    this.#transforms = transforms;
  }

  /**
   * Processes a movement intent.
   *
   * @param intent - Movement intent.
   */
  public process(intent: PTZ): void {
    let current = intent;

    for (const transform of this.#transforms) {
      const next =
        typeof transform === 'function' ? transform(current) : transform.transform(current);

      if (!next) {
        break;
      }

      current = next;
    }
  }
}
